import {z} from '@hono/zod-openapi';

export const priceReportArgumentFactKeySchema = z
  .enum([
    'price_position',
    'sold_vs_listed',
    'days_on_stock',
    'supply',
    'mileage_position',
    'mileage_threshold',
    'equipment_score',
    'key_features_present',
    'key_features_missing',
    'price_trend',
    'purchase_costs',
    'price_vs_sold',
    'market_situation',
    'months_of_inventory',
    'vat_deductible',
  ])
  .openapi('PriceReportArgumentFactKey');

export type PriceReportArgumentFactKey = z.infer<typeof priceReportArgumentFactKeySchema>;
